
export const createCheckoutUpdateData = (reservationData) => {
    const now = new Date();
    const currentDate = now.toISOString().split('T')[0];
    const currentTime = now.toTimeString().split(' ')[0];
    
    return {
        assetTag: reservationData.assetTag,
        userId: reservationData.userId,
        studentId: reservationData.studentId,
        reservationDate: reservationData.reservationDate ? reservationData.reservationDate.toString() : null,
        checkOut: currentDate,
        checkOutTime: currentTime,
        // Do not send check-in time when checking out - let backend preserve existing check-in time
        // This prevents accidental recalculation of check-in time
        status: 'CHECKED_OUT',
    };
};

export const createCheckinUpdateData = (reservationData) => {
    const now = new Date();
    const currentDate = now.toISOString().split('T')[0];
    const currentTime = now.toTimeString().split(' ')[0];
    
    return {
        assetTag: reservationData.assetTag,
        userId: reservationData.userId,
        studentId: reservationData.studentId,
        reservationDate: reservationData.reservationDate ? reservationData.reservationDate.toString() : null,
        checkOut: reservationData.checkOut ? reservationData.checkOut.toString() : null,
        checkOutTime: reservationData.checkOutTime ? reservationData.checkOutTime.toString() : null,
        checkIn: currentDate,
        checkInTime: currentTime,
        status: 'CHECKED_IN',
    };
};

export const handleCheckoutAction = (reservationData, handleReservation) => {
    const updateData = createCheckoutUpdateData(reservationData);
    handleReservation(updateData, reservationData.reservationId, 'checkOut');
};

export const handleCheckinAction = (reservationData, handleReservation) => {
    const updateData = createCheckinUpdateData(reservationData);
    handleReservation(updateData, reservationData.reservationId, 'checkIn');
};
